export default __webpack_public_path__ + "static/media/Playboi_Carti_Narcissist-0.25ETHM.db1d4f60.mp4";